import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiUrlProvider {
  private _url: string = `${environment.apiRoot}/api`;

  constructor() { }

  get url(): string{
    return this._url;
  }
}
